module.exports = __webpack_public_path__ + "img/1823.69530629.jpg";